/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiNurseryManagerCategoryCreateCategoryPost } from '../fn/category/api-nursery-manager-category-create-category-post';
import { ApiNurseryManagerCategoryCreateCategoryPost$Params } from '../fn/category/api-nursery-manager-category-create-category-post';
import { apiNurseryManagerCategoryCreateCategoryPost$Plain } from '../fn/category/api-nursery-manager-category-create-category-post-plain';
import { ApiNurseryManagerCategoryCreateCategoryPost$Plain$Params } from '../fn/category/api-nursery-manager-category-create-category-post-plain';
import { apiNurseryManagerCategoryDeleteCategoryDelete } from '../fn/category/api-nursery-manager-category-delete-category-delete';
import { ApiNurseryManagerCategoryDeleteCategoryDelete$Params } from '../fn/category/api-nursery-manager-category-delete-category-delete';
import { apiNurseryManagerCategoryDeleteCategoryDelete$Plain } from '../fn/category/api-nursery-manager-category-delete-category-delete-plain';
import { ApiNurseryManagerCategoryDeleteCategoryDelete$Plain$Params } from '../fn/category/api-nursery-manager-category-delete-category-delete-plain';
import { apiNurseryManagerCategoryGetCategoriesPost } from '../fn/category/api-nursery-manager-category-get-categories-post';
import { ApiNurseryManagerCategoryGetCategoriesPost$Params } from '../fn/category/api-nursery-manager-category-get-categories-post';
import { apiNurseryManagerCategoryGetCategoriesPost$Plain } from '../fn/category/api-nursery-manager-category-get-categories-post-plain';
import { ApiNurseryManagerCategoryGetCategoriesPost$Plain$Params } from '../fn/category/api-nursery-manager-category-get-categories-post-plain';
import { apiNurseryManagerCategoryGetCategoryPost } from '../fn/category/api-nursery-manager-category-get-category-post';
import { ApiNurseryManagerCategoryGetCategoryPost$Params } from '../fn/category/api-nursery-manager-category-get-category-post';
import { apiNurseryManagerCategoryGetCategoryPost$Plain } from '../fn/category/api-nursery-manager-category-get-category-post-plain';
import { ApiNurseryManagerCategoryGetCategoryPost$Plain$Params } from '../fn/category/api-nursery-manager-category-get-category-post-plain';
import { apiNurseryManagerCategoryGetStoresPost } from '../fn/category/api-nursery-manager-category-get-stores-post';
import { ApiNurseryManagerCategoryGetStoresPost$Params } from '../fn/category/api-nursery-manager-category-get-stores-post';
import { apiNurseryManagerCategoryGetStoresPost$Plain } from '../fn/category/api-nursery-manager-category-get-stores-post-plain';
import { ApiNurseryManagerCategoryGetStoresPost$Plain$Params } from '../fn/category/api-nursery-manager-category-get-stores-post-plain';
import { apiNurseryManagerCategoryUpdateCategoryPatch } from '../fn/category/api-nursery-manager-category-update-category-patch';
import { ApiNurseryManagerCategoryUpdateCategoryPatch$Params } from '../fn/category/api-nursery-manager-category-update-category-patch';
import { apiNurseryManagerCategoryUpdateCategoryPatch$Plain } from '../fn/category/api-nursery-manager-category-update-category-patch-plain';
import { ApiNurseryManagerCategoryUpdateCategoryPatch$Plain$Params } from '../fn/category/api-nursery-manager-category-update-category-patch-plain';
import { CreateCategoryCommandResult } from '../models/create-category-command-result';
import { DeleteCategoryCommandResult } from '../models/delete-category-command-result';
import { GetCategoriesResult } from '../models/get-categories-result';
import { GetCategoryResult } from '../models/get-category-result';
import { GetStoresQueryResult } from '../models/get-stores-query-result';
import { UpdateCategoryCommandResult } from '../models/update-category-command-result';

@Injectable({ providedIn: 'root' })
export class CategoryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiNurseryManagerCategoryGetCategoriesPost()` */
  static readonly ApiNurseryManagerCategoryGetCategoriesPostPath = '/api/NurseryManager/Category/GetCategories';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerCategoryGetCategoriesPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerCategoryGetCategoriesPost$Plain$Response(params?: ApiNurseryManagerCategoryGetCategoriesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCategoriesResult>> {
    return apiNurseryManagerCategoryGetCategoriesPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerCategoryGetCategoriesPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerCategoryGetCategoriesPost$Plain(params?: ApiNurseryManagerCategoryGetCategoriesPost$Plain$Params, context?: HttpContext): Observable<GetCategoriesResult> {
    return this.apiNurseryManagerCategoryGetCategoriesPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetCategoriesResult>): GetCategoriesResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerCategoryGetCategoriesPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerCategoryGetCategoriesPost$Response(params?: ApiNurseryManagerCategoryGetCategoriesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCategoriesResult>> {
    return apiNurseryManagerCategoryGetCategoriesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerCategoryGetCategoriesPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerCategoryGetCategoriesPost(params?: ApiNurseryManagerCategoryGetCategoriesPost$Params, context?: HttpContext): Observable<GetCategoriesResult> {
    return this.apiNurseryManagerCategoryGetCategoriesPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetCategoriesResult>): GetCategoriesResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerCategoryGetStoresPost()` */
  static readonly ApiNurseryManagerCategoryGetStoresPostPath = '/api/NurseryManager/Category/GetStores';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerCategoryGetStoresPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerCategoryGetStoresPost$Plain$Response(params?: ApiNurseryManagerCategoryGetStoresPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetStoresQueryResult>> {
    return apiNurseryManagerCategoryGetStoresPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerCategoryGetStoresPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerCategoryGetStoresPost$Plain(params?: ApiNurseryManagerCategoryGetStoresPost$Plain$Params, context?: HttpContext): Observable<GetStoresQueryResult> {
    return this.apiNurseryManagerCategoryGetStoresPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetStoresQueryResult>): GetStoresQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerCategoryGetStoresPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerCategoryGetStoresPost$Response(params?: ApiNurseryManagerCategoryGetStoresPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetStoresQueryResult>> {
    return apiNurseryManagerCategoryGetStoresPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerCategoryGetStoresPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerCategoryGetStoresPost(params?: ApiNurseryManagerCategoryGetStoresPost$Params, context?: HttpContext): Observable<GetStoresQueryResult> {
    return this.apiNurseryManagerCategoryGetStoresPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetStoresQueryResult>): GetStoresQueryResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerCategoryGetCategoryPost()` */
  static readonly ApiNurseryManagerCategoryGetCategoryPostPath = '/api/NurseryManager/Category/GetCategory';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerCategoryGetCategoryPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerCategoryGetCategoryPost$Plain$Response(params?: ApiNurseryManagerCategoryGetCategoryPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCategoryResult>> {
    return apiNurseryManagerCategoryGetCategoryPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerCategoryGetCategoryPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerCategoryGetCategoryPost$Plain(params?: ApiNurseryManagerCategoryGetCategoryPost$Plain$Params, context?: HttpContext): Observable<GetCategoryResult> {
    return this.apiNurseryManagerCategoryGetCategoryPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetCategoryResult>): GetCategoryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerCategoryGetCategoryPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerCategoryGetCategoryPost$Response(params?: ApiNurseryManagerCategoryGetCategoryPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCategoryResult>> {
    return apiNurseryManagerCategoryGetCategoryPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerCategoryGetCategoryPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerCategoryGetCategoryPost(params?: ApiNurseryManagerCategoryGetCategoryPost$Params, context?: HttpContext): Observable<GetCategoryResult> {
    return this.apiNurseryManagerCategoryGetCategoryPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetCategoryResult>): GetCategoryResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerCategoryCreateCategoryPost()` */
  static readonly ApiNurseryManagerCategoryCreateCategoryPostPath = '/api/NurseryManager/Category/CreateCategory';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerCategoryCreateCategoryPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerCategoryCreateCategoryPost$Plain$Response(params?: ApiNurseryManagerCategoryCreateCategoryPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateCategoryCommandResult>> {
    return apiNurseryManagerCategoryCreateCategoryPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerCategoryCreateCategoryPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerCategoryCreateCategoryPost$Plain(params?: ApiNurseryManagerCategoryCreateCategoryPost$Plain$Params, context?: HttpContext): Observable<CreateCategoryCommandResult> {
    return this.apiNurseryManagerCategoryCreateCategoryPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateCategoryCommandResult>): CreateCategoryCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerCategoryCreateCategoryPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerCategoryCreateCategoryPost$Response(params?: ApiNurseryManagerCategoryCreateCategoryPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateCategoryCommandResult>> {
    return apiNurseryManagerCategoryCreateCategoryPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerCategoryCreateCategoryPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerCategoryCreateCategoryPost(params?: ApiNurseryManagerCategoryCreateCategoryPost$Params, context?: HttpContext): Observable<CreateCategoryCommandResult> {
    return this.apiNurseryManagerCategoryCreateCategoryPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateCategoryCommandResult>): CreateCategoryCommandResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerCategoryUpdateCategoryPatch()` */
  static readonly ApiNurseryManagerCategoryUpdateCategoryPatchPath = '/api/NurseryManager/Category/UpdateCategory';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerCategoryUpdateCategoryPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerCategoryUpdateCategoryPatch$Plain$Response(params?: ApiNurseryManagerCategoryUpdateCategoryPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateCategoryCommandResult>> {
    return apiNurseryManagerCategoryUpdateCategoryPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerCategoryUpdateCategoryPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerCategoryUpdateCategoryPatch$Plain(params?: ApiNurseryManagerCategoryUpdateCategoryPatch$Plain$Params, context?: HttpContext): Observable<UpdateCategoryCommandResult> {
    return this.apiNurseryManagerCategoryUpdateCategoryPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateCategoryCommandResult>): UpdateCategoryCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerCategoryUpdateCategoryPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerCategoryUpdateCategoryPatch$Response(params?: ApiNurseryManagerCategoryUpdateCategoryPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateCategoryCommandResult>> {
    return apiNurseryManagerCategoryUpdateCategoryPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerCategoryUpdateCategoryPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerCategoryUpdateCategoryPatch(params?: ApiNurseryManagerCategoryUpdateCategoryPatch$Params, context?: HttpContext): Observable<UpdateCategoryCommandResult> {
    return this.apiNurseryManagerCategoryUpdateCategoryPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateCategoryCommandResult>): UpdateCategoryCommandResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerCategoryDeleteCategoryDelete()` */
  static readonly ApiNurseryManagerCategoryDeleteCategoryDeletePath = '/api/NurseryManager/Category/DeleteCategory';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerCategoryDeleteCategoryDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerCategoryDeleteCategoryDelete$Plain$Response(params?: ApiNurseryManagerCategoryDeleteCategoryDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteCategoryCommandResult>> {
    return apiNurseryManagerCategoryDeleteCategoryDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerCategoryDeleteCategoryDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerCategoryDeleteCategoryDelete$Plain(params?: ApiNurseryManagerCategoryDeleteCategoryDelete$Plain$Params, context?: HttpContext): Observable<DeleteCategoryCommandResult> {
    return this.apiNurseryManagerCategoryDeleteCategoryDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteCategoryCommandResult>): DeleteCategoryCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerCategoryDeleteCategoryDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerCategoryDeleteCategoryDelete$Response(params?: ApiNurseryManagerCategoryDeleteCategoryDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteCategoryCommandResult>> {
    return apiNurseryManagerCategoryDeleteCategoryDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerCategoryDeleteCategoryDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerCategoryDeleteCategoryDelete(params?: ApiNurseryManagerCategoryDeleteCategoryDelete$Params, context?: HttpContext): Observable<DeleteCategoryCommandResult> {
    return this.apiNurseryManagerCategoryDeleteCategoryDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteCategoryCommandResult>): DeleteCategoryCommandResult => r.body)
    );
  }

}
